<template>
  <div class="boss-checkbox-button-group">
    <div class="boss-checkbox-button-group-title">
      表示対象者
    </div>
    <div>
      <label
        class="boss-checkbox-button"
      >
        <input
          v-model="selected"
          :value="entryStatusIds"
          type="checkbox"
          class="boss-checkbox-button-input"
          data-test="entryStatusIds"
        >
        <span
          class="boss-checkbox-button-content"
          data-test="entryStatusNames"
        >エントリー中</span>
      </label>
    </div>
    <div>
      <label
        :id="`display-target-${finishStatusId}`"
        class="boss-checkbox-button"
      >
        <input
          v-model="selected"
          :value="finishStatusId"
          type="checkbox"
          class="boss-checkbox-button-input"
          data-test="finishStatusId"
        >
        <span
          class="boss-checkbox-button-content"
          data-test="finishStatusName"
        >終了</span>
      </label>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
  props: {
    entryObjects: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      selected: []
    }
  },
  computed: {
    finishStatusId: () => 5,
    entryStatusIds () {
      return _([{ id: null, name: '' }, ...this.seminarStatuses]).filter(status => status.id !== this.finishStatusId).map('id').value()
    },
    selectedStatuses () {
      return _.flatten(this.selected)
    },
    ...mapGetters({
      seminarStatuses: 'seminarStatuses'
    })
  },
  watch: {
    selectedStatuses (value) {
      this.filteredUpdate(this.entryObjects, value)
      this.$emit('setDisplayTargets', value)
    },
    entryObjects: {
      handler (value) {
        this.filteredUpdate(value, this.selectedStatuses, false)
      },
      deep: true
    },
    seminarStatuses: {
      handler (value) {
        value.length && !_.some(this.selected, val => {
          return _.isEqual(this.entryStatusIds, val)
        }) && this.selected.push(this.entryStatusIds)
      },
      immediate: true
    }
  },
  methods: {
    filteredUpdate (entryObjects, selectedStatuses, checkedRest = true) {
      _.forEach(entryObjects, o => {
        // 選択されている表示対象者だけ表示
        o.isDisplayTarget = _.includes(selectedStatuses, _.get(o, 'entry.statusId'))
        // フィルターがかかったらチェック状況をリセット
        if (checkedRest) {
          o.isChecked = false
        }
      })
      this.$emit('filteredUpdate', entryObjects)
    }
  }
}
</script>
